import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsCenterSettings from './endpoints'

const CenterSettingsService = {
  aspiratorTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(
        endpointsCenterSettings.aspiratorTypes.LOAD(filter, sort, limit, skip),
      ),
    getById: async (id) =>
      GET(endpointsCenterSettings.aspiratorTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.aspiratorTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.aspiratorTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.aspiratorTypes.LOAD_BY_ID(id)),
  },

  comercialData: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(
        endpointsCenterSettings.comercialData.LOAD(filter, sort, limit, skip),
      ),
    getById: async (id) =>
      GET(endpointsCenterSettings.comercialData.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.comercialData.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.comercialData.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.comercialData.LOAD_BY_ID(id)),
  },

  gasTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(endpointsCenterSettings.gasTypes.LOAD(filter, sort, limit, skip)),
    getById: async (id) => GET(endpointsCenterSettings.gasTypes.LOAD_BY_ID(id)),
    create: async (body) => POST(endpointsCenterSettings.gasTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.gasTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.gasTypes.LOAD_BY_ID(id)),
  },

  heaterTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(endpointsCenterSettings.heaterTypes.LOAD(filter, sort, limit, skip)),
    getById: async (id) =>
      GET(endpointsCenterSettings.heaterTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.heaterTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.heaterTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.heaterTypes.LOAD_BY_ID(id)),
  },

  otherTecnicsTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(
        endpointsCenterSettings.otherTecnicsTypes.LOAD(
          filter,
          sort,
          limit,
          skip,
        ),
      ),
    getById: async (id) =>
      GET(endpointsCenterSettings.otherTecnicsTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.otherTecnicsTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.otherTecnicsTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.otherTecnicsTypes.LOAD_BY_ID(id)),
  },

  plattenTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(endpointsCenterSettings.plattenTypes.LOAD(filter, sort, limit, skip)),
    getById: async (id) =>
      GET(endpointsCenterSettings.plattenTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.plattenTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.plattenTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.plattenTypes.LOAD_BY_ID(id)),
  },

  serviceTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(endpointsCenterSettings.serviceTypes.LOAD(filter, sort, limit, skip)),
    getById: async (id) =>
      GET(endpointsCenterSettings.serviceTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.serviceTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.serviceTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.serviceTypes.LOAD_BY_ID(id)),
  },

  soapTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(endpointsCenterSettings.soapTypes.LOAD(filter, sort, limit, skip)),
    getById: async (id) =>
      GET(endpointsCenterSettings.soapTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.soapTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.soapTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.soapTypes.LOAD_BY_ID(id)),
  },

  trackTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(endpointsCenterSettings.trackTypes.LOAD(filter, sort, limit, skip)),
    getById: async (id) =>
      GET(endpointsCenterSettings.trackTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.trackTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.trackTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.trackTypes.LOAD_BY_ID(id)),
  },

  washingTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(endpointsCenterSettings.washingTypes.LOAD(filter, sort, limit, skip)),
    getById: async (id) =>
      GET(endpointsCenterSettings.washingTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.washingTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.washingTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.washingTypes.LOAD_BY_ID(id)),
  },

  maintenanceTypes: {
    getAll: async ({ filter, sort, limit, skip }) =>
      GET(
        endpointsCenterSettings.maintenanceTypes.LOAD(
          filter,
          sort,
          limit,
          skip,
        ),
      ),
    getById: async (id) =>
      GET(endpointsCenterSettings.maintenanceTypes.LOAD_BY_ID(id)),
    create: async (body) =>
      POST(endpointsCenterSettings.maintenanceTypes.CREATE, body),
    update: async ({ _id, body }) =>
      PATCH(endpointsCenterSettings.maintenanceTypes.LOAD_BY_ID(_id), body),
    remove: async (id) =>
      DELETE(endpointsCenterSettings.maintenanceTypes.LOAD_BY_ID(id)),
  },
}

export default CenterSettingsService
